import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FlowChartDesignerComponent} from '../flow-chart-designer/flow-chart-designer.component';
import {FlowChartDataService, IFlowChartDataService} from '../../../services/flow-chart-data.service';
import {SmartGridService} from '@core/services/smart-grid.service';
import {take, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {SnackBarService} from '@core/services/snack-bar.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {DetailsInstructionService, InstructionDetailsSourceViewType} from '@shared/services/details-instruction-service';
import {Configuration} from '@shared/models/configuration';

@Component({
    standalone: false,
    selector: 'particle-flow-chart-group-view',
  templateUrl: './flow-chart-group-view.component.html',
  styleUrls: ['./flow-chart-group-view.component.scss']
})
export class FlowChartGroupViewComponent implements OnInit, OnDestroy {
  @Input() section: any;
  @Input() totalSections: number;
  @Input() sourceType: string;
  @Input() flowChartDataService: IFlowChartDataService;
  @Input() flowchart: any;
  unsubscribe$ = new Subject<void>();

  @ViewChild('flowChartDesigner') flowChartDesigner: FlowChartDesignerComponent;
  public isManageFields: boolean;
  public canAddExternalField: boolean;

  constructor(private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private smartGridService: SmartGridService,
              private dialogService: DialogService,
              private commandService: CommandService,
              private detailsInstructionService: DetailsInstructionService
  ) {

  }

  ngOnInit() {
    this.isManageFields = this.flowChartDataService.getIsManageFields();
    const gridConfig = Configuration.getSmartGridConfig(this.sourceType);
    if(gridConfig && gridConfig.CanAddExternalField) {
      this.canAddExternalField = true;
    } else {
      this.canAddExternalField = false;
    }
  }

  addNewItem(isAddedAsField: boolean) {
    this.flowChartDesigner.onAdd(null, isAddedAsField);
  }

  addExternalNewItem() {
    this.flowChartDesigner.onExternalAdd();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  deleteSection() {
    const dialogModel: DialogModel = DialogModel.create(
      'Delete Section',
      'DeleteSectionDialogComponent', {
        flowchartId: this.section.flowchartId,
        section: this.section
      },
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.deleteSectionCommandExecute(res, this.section);
      }
    });
  }


  renameSection() {
    const dialogModel: DialogModel = DialogModel.create(
      'Rename Section',
      'RenameTitleDialogComponent', {
        fieldName: 'Section Name', name: this.section.title
      },
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.renameSectionCommandExecute(res, this.section);
      }
    });
  }

  addSection() {
    const dialogModel: DialogModel = DialogModel.create(
      'Add Section',
      'RenameTitleDialogComponent', {
        fieldName: 'Section Name', name: ''
      },
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.addSectionCommandExecute(res, this.section);
      }
    });
  }

  editDetailsAndInstruction() {
    if (this.isManageFields) {
      this.detailsInstructionService.openDetailsInstructionPopUp(InstructionDetailsSourceViewType.flowchart, this.sourceType, this.section.title);
    } else {
      this.detailsInstructionService.openDetailsInstructionPopUp(InstructionDetailsSourceViewType.flowchart, this.flowchart.sourceType, this.section.title);
    }
  }
}
